/**
 * Извлекаем дату из строки
 *
 * @param {string} str - строка с датой, например: 22 ноября 2020
 *
 * @returns {Date}
 */

const MONTHS = [
  'январь|января|january',
  'февраль|февраля|february',
  'март|марта|march',
  'апрель|апреля|april',
  'май|мая|may',
  'июнь|июня|june',
  'июль|июля|july',
  'август|августа|august',
  'сентябрь|сентября|september',
  'октябрь|октября|october',
  'ноябрь|ноября|november',
  'декабрь|декабря|december',
];

export default (str) => {
  if (!str) return null;

  let [, day,, month,, year] = str.match(/(\d{1,2})(\s+)?([\wа-я]{1,})?(\s+)?(\d{4})?/i) || [];
  let monthIndex = -1;

  day = Number(day);

  if (!day || day > 31 || !month) return null;

  month = month.trim().toLowerCase();
  monthIndex = MONTHS.findIndex((el) => el.includes(month));

  if (monthIndex === -1) return null;

  month = monthIndex + 1;
  year = year || new Date().getFullYear();

  return new Date([
    String(year),
    String(month).padStart(2, '0'),
    String(day).padStart(2, '0'),
  ].join('-'));
};
